export const SSO_LOGIN_REDIRECT = '/ipm/public/ssoConfig/loginPage';
export const URL_TRACKER_COOKIE = 'ngpGo';
export const UNAUTHORIZED_REDIRECT_COOKIE = 'ngpUnauthorizedRedirect';
